const focusableSelector = [
  "a[href]:not([tabindex='-1'])",
  "area[href]:not([tabindex='-1'])",
  "input:not([disabled]):not([tabindex='-1']):not([type='hidden'])",
  "select:not([disabled]):not([tabindex='-1'])",
  "textarea:not([disabled]):not([tabindex='-1'])",
  "button:not([disabled]):not([tabindex='-1'])",
  "iframe:not([tabindex='-1'])",
  "[tabindex]:not([tabindex='-1'])",
  "[contentEditable=true]:not([tabindex='-1'])",
].join(",");

function triggerSelfClick(e) {
  if (e.key === "Enter") {
    e.target.click();
  }
}

$(document).ready(function () {
  $("html").attr("data-page-url", window.location.pathname);
  
  $("body").append('<div class="sr-only live-status-region" role="status"></div>');

  $('.stamped-summary-ratings').each((i, summary) => {

    $(summary).find('.summary-rating-count').each((i, count) => {
      $(count).append('<span class="visually-hidden">reviews</span>');
    })
  
    let searchInterval;
    
    $(summary).find('.summary-rating-title').each((i, button) => {
      function findElement() {
          const targetElement = document.querySelector(".stamped-reviews");
  
          if (targetElement && $(targetElement).children().first().hasClass('stamped-review')) {
              clearInterval(searchInterval);
              $('.stamped-reviews > .stamped-review').first().find('.stamped-review-header-title').first().attr('tabindex', -1).focus();
          }
      }
  
      function startSearching() {
          searchInterval = setInterval(findElement, 1000);
      }
  
      $(button).on('click', (e) => {
        startSearching();
      });
    });
  });
  
  function fixRatingStars() {
    $(
      ".stamped-summary-ratings > .summary-rating > .summary-rating-title"
    ).each(function () {
      const count = $(this).next().attr("data-rating");
      $(this).attr({
        role: "button",
        "aria-label": count + (count == 1 ? " Star Ratings" : " Stars Ratings"),
      });
    });

    const bigRating = document.querySelector(
      ".summary-overview .stamped-summary-caption.stamped-summary-caption-1"
    );
    const bigRatingSRTEXT = document.querySelector(
      ".summary-overview .stamped-summary-caption.stamped-summary-caption-1 .visually-hidden"
    );
    if (bigRatingSRTEXT) {
      bigRatingSRTEXT.remove();
    }
    $(
      ".summary-overview .stamped-summary-caption.stamped-summary-caption-1"
    ).prepend('<span class="visually-hidden">Rating: </span>');
    
    // $('.stamped-reviews .stamped-review').each(function(){
    // var authortext = $(this).find('.author').text().trim();
    // var sharetext = $(this).find('.stamped-share-icon').text().trim();
    // $(this).find('.stamped-share-icon').attr('aria-label',sharetext +' review of '+ authortext);
    // });
    $(".stamped-review-share .stamped-share-icon").attr(
      "aria-expanded",
      "false"
    );
    $(".stamped-review-share .stamped-share-icon").click(function () {
      $(this).attr("aria-expanded", $(this).attr("aria-expanded") == "false");
    });
  }
  fixRatingStars();
  addEventListenerStamped(document, "stamped:reviews:loaded", function (e) {
    fixRatingStars();
  });
  var div = $(".site-nav__icons");
  div.children().wrapAll('<ul class="a11y_custom">').wrap("<li>");
  $("p.h4.footer__title").attr({
    role: "heading",
    "aria-level": "2",
  });
  $(".site-nav__link.site-nav__link--icon.js-drawer-open-cart").removeAttr(
    "aria-expanded"
  );
  $(".section-header").each(function () {
    var text = $(this).find("h2").text().trim();
    var linktext = $(this).find("a").text().trim();
    $(this)
      .find("a")
      .attr("aria-label", linktext + " " + text);
  });
  setTimeout(function () {
    $(".octane-ai-quiz-rendered").removeAttr("tabindex");
    $('#shopify-section-footer-klaviyo form input[type="email"]').before(
      "<label>Email</label>"
    );
    $('#shopify-section-footer-klaviyo form input[type="email"]').attr(
      "aria-label",
      "Email for join us"
    );
    // $('.product-slideshow.flickity-enabled .product-main-slide').removeAttr('tabindex');
  }, 2000);

  $(".flickity-page-dots li").attr({ role: "button", tabindex: "0" });
  $(".flickity-page-dots li").keydown(function (event) {
    if (event.which == "13") {
      $(this).click();
    }
  });

  function setSelectedAriaCurrent() {
    $(".dot").each(function () {
      const $dot = $(this);
      const isSelected = $dot.hasClass("is-selected");

      if (isSelected) {
        $dot.attr("aria-current", "true");
      } else {
        $dot.removeAttr("aria-current");
      }
    });
  }

  // Initially set the aria-current attribute
  setSelectedAriaCurrent();

  // Use MutationObserver to detect changes in the "is-selected" class
  const observer = new MutationObserver(setSelectedAriaCurrent);

  // Observe changes in the class attribute of the list items
  $(".dot").each(function () {
    observer.observe(this, { attributes: true, attributeFilter: ["class"] });
  });

  $('.hero').each((i, hero) => {
    $(hero).find('.slideshow__slide').each((i, slide) => {
      const textWrap = $(slide).find('.hero__text-wrap');

      textWrap.on('click', () => {
        const link = textWrap.find('.hero__link a').attr('href');
        
        if(link) {
          window.location.assign(link)
        }
      })
        
      const observer = new MutationObserver((mutations) => {
        const selector = 'a, button, input, textarea, select';
        
        if($(slide).attr('aria-hidden') === 'true') {
          $(slide).find(selector).attr('tabindex', -1);
        } else {
          $(slide).find(selector).removeAttr('tabindex');
        }
      });

      observer.observe(slide, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    });
    
    $(hero).find('.flickity-page-dots').each((i, dots) => {
      $(dots).attr('role', 'none');
      $(dots).find('.dot').each((i, dot) => {
        $(dot).attr('aria-label', `Slide ${i + 1}`);
      })
    });
  });

  $(".product-block .table-wrapper tr")
    .first()
    .find("td")
    .attr({ role: "columnheader", scope: "col" });
  $(".product-block .table-wrapper table").prepend(
    '<caption class="sr-only">Size Chart</caption>'
  );

  $(".a11y_h2").attr({ role: "heading", "aria-level": "2" });
  $("#AnnouncementSlider").removeAttr("tabindex");

  $(".slideshow-wrapper").each((i, slideshow) => {
    const slides = $(slideshow).find('.slideshow__slide');
    const pause = $(slideshow).find('.slideshow__pause');
    
    $(slideshow).find('.hero').removeAttr("tabindex");

    if(slides.length <= 1) {
      pause.hide()
    }
  });

  $('.site-footer').each((i, footer) => {
		const copyright = $(footer).find('div[data-type="newsletter"]');
		const form = $(`
			<form class="color-scheme-form">
				<label for="color-scheme-switcher">Color Scheme</label>
				<select class="color-scheme-switcher" id="color-scheme-switcher">
					<option value="default">Default</option>
					<option value="accessible">Accessible</option>
				</select>
			</form>
		`)
		
		const selectedValue = localStorage.getItem('color-scheme');
		const select = form.find('#color-scheme-switcher');
		
		select.on('change', (e) => {
			$(':root').attr({
				'data-color-scheme': e.target.value
			});
			
			localStorage.setItem('color-scheme', e.target.value);
		});
		
		if (selectedValue) {
			$(':root').attr({
				'data-color-scheme': selectedValue || value
			});
			
			select.val(selectedValue);
		}

		copyright.append(form);
	});


  $('.site-nav').each(function () {
  var hasclass = $(this).find('.site-nav--has-dropdown');
    
    $(this).find('.site-nav--has-dropdown').each(function(i, li) {
      var button = $(this).children('.site-nav__link--has-dropdown');
      var submenu = $(this).children('ul.site-nav__dropdown');

      button.on('mouseenter mouseover', (e) => {
        submenu.removeClass('menu_hidden');
        submenu.removeAttr('style');
      });
      
      button.keydown(function (events) {
        if(events.which == "13"){
          submenu.removeClass('menu_hidden');
          if($(this).hasClass('is-focused')) {
            $(this).removeClass('is-focused');
          }
        }

        if(events.key === 'Tab' && !events.shiftKey) {
          submenu.removeClass('menu_hidden');
        }
      });
      $(this).find("a").last().on("keydown", (e) => {
			  if (e.key === "Tab" && !e.shiftKey) {
				li.classList.remove("is-focused");
			  }
			});
      
      $(this).keydown(function (events) {
        if(events.which == "27"){
          $(this).removeClass('is-focused');          
          button.focus();
          submenu.addClass('menu_hidden');
        }
      });

      const observer = new MutationObserver((mutations) => {
        button.attr('aria-expanded', li.classList.contains('is-focused'));
      });

      observer.observe(li, {
        attributes: true,
        attributeFilter: ['class']
      });

    })     
  });

  $("h1,h2,h3,h4,h5,h6").each((i, title) => {
    const content = title.textContent.trim();
    if (!content || content === "" || content === " " || content === "&nbsp;") {
      title.remove();
    }
  });

  $('.visually-invisible').each((i, el) => {
    el.removeAttribute('aria-hidden');
  });
  
  document.addEventListener('keydown', function(event){
      if(event.key === "Escape"){
          document.body.style.pointerEvents = 'none';
      }
  });
	
  document.addEventListener('mousemove', function(event){
      document.body.style.pointerEvents = 'auto';
  });


  $('.site-header__search-container').each((i, search) => {
    const input = search.querySelector('.site-header__search-input');
    const close = $(search).find('#SearchClose');
    const results = $(search).find('.predictive-results');

    close.on('click', () => {
      $('.site-nav__link.js-search-header').focus();
    });

    close.attr('aria-label', 'Clear search input');
    
    const announceSearchResults = debounce(() => {
      if (input.value.length < 1) {
        return;
      }

      const predictive = $(search).find('.predictive-result__layout');
      
      let annoucement_string = ``;

      predictive.children('div').each((i, div) => {
        if(div.hasAttribute('data-type-products')) {
          annoucement_string = `${$(div).find('> div.grid > div').length} Products found`
        } else {
          annoucement_string = `${annoucement_string}, ${$(div).find('> ul > li').length} ${$(div).find('.predictive__label').text().replace(':', '')} found`
        }
      });

      announceToScreenReader(annoucement_string);
    }, 1000);


    close.on('keydown', (e) => {
      if (e.key === "Tab" && !e.shiftKey) {
        if(results.find('#PredictiveResults').is(':empty')) {
          e.preventDefault();
          $(search).find(focusableSelector).first().focus();
        }
      }
    });

    $(input).on("input change", (e) => {
      announceSearchResults();

      setTimeout(() => {
        if(!results.find('#PredictiveResults').is(':empty')) {
          const lastFocusable = results.find(focusableSelector).last();
          
          console.log(lastFocusable);

          lastFocusable.on('keydown', (e) => {
            if (e.key === "Tab" && !e.shiftKey) {
              e.preventDefault();
              $(search).find(focusableSelector).first().focus();
            }
          });
        }
      }, 2000);
    });

    const classObserver = new MutationObserver(() => {
      if(search.classList.contains('is-active')) {
        $(search).parents().siblings().not('.live-status-region').attr("aria-hidden", true);
        $(search).siblings().attr('aria-hidden', true);
      } else {
        $(search).parents().siblings().removeAttr("aria-hidden");
        $(search).siblings().removeAttr("aria-hidden");
      }
    });

    classObserver.observe(search, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  $('.tag-list').each((i, tagList) => {
    const group = $(tagList).closest('.collection-sidebar__group');
    const button = group.find('.collapsible-trigger');
    const content = group.find('.collapsible-content');

    content.attr({
      'role': 'group',
      'aria-label': `${button.text().trim()}`
    })
    
    $(tagList).find('label.tag__checkbox-wrapper').each((i, label) => {
      const input = $(label).find('input.tag__input');
      input.attr({
        'role': 'checkbox',
        'aria-label': `${label.textContent.trim()}`
      });
    });
  });

  function handleCartItem(item, i = 0) {
    const name = $(item).find(".cart__item-name").text().replace(/&nbsp;/g, " ").trim();
    const label = $(item).find('label');
    const input = $(item).find('.js-qty__num');
    
    input.attr('aria-label', `${name} ${label.text().trim()}`);

    $(item).find('.js-qty__adjust').each((i, button) => {
      $(button).attr('aria-label', `${button.getAttribute('aria-label').trim()} (${name})`);

      $(button).on('click', (e) => {
        setTimeout(() => {
          $(`.cart__item[data-key="${item.getAttribute('data-key')}"]`).find(`[class="${button.getAttribute('class')}"]`).focus();
          announceToScreenReader(`${input.attr('aria-label')} is changed to ${input.val()}`);
        }, 1500);
      });
    });

    $(item).find('.cart__remove a').attr('role', 'button');
  }

  $('.cart__item').each((i, item) => {
    handleCartItem(item, i);
  });

  $('#CartDrawer').each((i, drawer) => {
    const trigger = $('a[aria-controls="CartDrawer"]');
    const addToCart = $('.product-single__meta .add-to-cart');
    
    trigger.add(addToCart).on('click', () => {
      trapFocus(drawer);
    });

    $(drawer).find('.drawer__close-button').on('click', () => {
      trigger.focus();
    });
    
    setTimeout(() => {
     $(drawer).find('.cart__item').each((i, item) => {
        handleCartItem(item, i);
      });
      
      trigger.attr('aria-label', `${trigger.text().trim()}: ${$(drawer).find('.cart__item').length} added`);
    }, 250);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!node || !node.classList) {
            continue;
          }

          if(node.classList.contains('cart__items')) {
            $(node).find('.cart__item').each((i, item) => {
              handleCartItem(item, i);
            });
          }
        }
      }
    });

    const products = drawer.querySelector('div[data-products]');

    if(products) {
      observer.observe(products, {
        childList: true,
        subtree: true
      });
    }
    
  });

  function handleAfterpayModal() {
    $('afterpay-modal').each((i, modal) => {
      const root = modal.shadowRoot;
      
      $(root).find('.afterpay-modal-headline').attr({
        'role': 'heading',
        'aria-level': 2
      });

      $(root).find('.disclaimer-link').attr({
        'aria-label': function () {
          return `${$(this).text().trim()} ${$(this).attr('aria-label')}`
        }
      });
    });
  }

  $('afterpay-placement').each((i, afterpay_placement) => {
    const root = afterpay_placement.shadowRoot;

    $(root).find('.afterpay-logo, .afterpay-link').each((i, button) => {
      $(button).on('click', (e) => {
        setTimeout(() => {
          handleAfterpayModal();
        }, 500);
      });
    });
  });

  $('.stamped-tab-container').each((i, container) => {
    const tabs = $(container).find('[role="tab"]');

    tabs.each((i, tab) => {
      $(tab).attr({
        'aria-label': function() {
          return `${$(this).attr('aria-label')} ${$(this).attr('data-count')}`
        }
      })
    })
  });

  $('.variant-wrapper').each((i, wrapper) => {
    const label = $(wrapper).children('label.variant__label');

    $(wrapper).children('fieldset').attr({
      'role': 'group',
      'aria-label': `${label.text().trim()}`
    })
  });

  $('.payment-buttons').each((i, buttons) => {
    $(buttons).find('.add-to-cart').each((i, button) => {
      const observer = new MutationObserver((mutations) => {
        if(button.classList.contains('btn--loading')) {
          announceToScreenReader('Adding to cart')
        }
      });

      observer.observe(button, {
        attributes: true,
        attributeFilter: ['class']
      });
    })
  });

  $('body').each((i, body) => {
    const observer = new MutationObserver((mutations) => {
      const modal = body.querySelector('#shopify-payment-terms-cover');
      if(modal) {
        $(modal).siblings().not('.live-status-region').attr('aria-hidden', true) 
      } else {
        $(body).children().removeAttr('aria-hidden')
      }
    });

    observer.observe(body, {
      childList: true
    });
  });

  $('.stamped-summary').each((i, summary) => {
    $(summary).find('.summary-rating-title').each((i, stars) => {
      $(stars).attr({
        'role': 'button',
        'tabindex': 0
      });
    });
  });

  $('.product-block--description-tabs').each((i, tabs) => {
    $(tabs).find('.tab--radio').each((i, radio) => {
      const label = $(tabs).find(`label[for="${$(radio).attr('id')}"]`);
      
      $(radio).attr({
        'tabindex': 0,
        'role': 'button',
        'type': 'button',
        'aria-label': `${label.text().trim()}`
      });

      $(radio).removeAttr('checked');

      label.attr('aria-hidden', true);

      $(radio).on('click', () => {
        $(tabs).find('.tab--radio.selected').removeClass('selected').attr('aria-label', `${label.text().trim()}`);
        $(radio).addClass('selected');
        
        $(tabs).find('.tab--panel.selected').removeClass('selected');
        $(tabs).find('.tab--panel').eq(i).addClass('selected');
        
        $(radio).attr('aria-label', `${label.text().trim()} selected`);
      });

      if(i === 0) {
        $(radio).addClass('selected').attr('aria-label', `${label.text().trim()} selected`);
      }
    });

    $(tabs).find('.tab--panel').each((i, panel) => {
      $(panel).removeAttr('tabindex');
      $(tabs).append(panel);

      if(i === 0) {
        panel.classList.add('selected')
      }

      $(panel).find('table').attr('role', 'none');
    });

    $(tabs).find('.size-help table, label[for="tab-size-help"] + div table').each((i, table) => {
      $(table).attr('role', 'none');
    });

    $(tabs).find('label[for="tab-size-help"] + div table').each((i, table) => {
      $(table).find('tr td p > strong[data-mce-fragment]').each((i, heading) => {
        if($(heading).children('span').length < 1) {
          $(heading).attr({
            'role': 'heading',
            'aria-level': 2
          });
        };
      });
    });

    $(tabs).find('label[for="tab-care-fabric"] + div').each((i, panel) => {
      $(panel).find('p > strong').each((i, strong) => {
        $(strong).attr({
          'role': 'heading',
          'aria-level': 2
        })
      })
    });
  });

  $('.size-help table').each((i, table) => {
    $(table).children('tbody').attr('role', 'list');
    
    $(table).find('> tbody > tr').attr('role', 'listitem');
    
    $(table).find('> tbody > tr').last().attr('role', 'presentation').insertAfter(table);
  });

  $('.stamped-questions-search-icon').attr('aria-hidden', true);

  $('div[data-product-images]').each((i, images) => {
    $(images).find('.product__thumb').each((i, thumb) => {
      function announceSlideChange() {
        announceToScreenReader(`You are on slide ${parseInt($(thumb).attr('data-index')) + 1}`, 'status', 100, true);
      }
      
      $(thumb).on('click', (e) => {
        announceSlideChange();
      });

      $(thumb).on('focus', (e) => {
        announceSlideChange();
      });

      $(thumb).attr({
        'tabindex': 0,
        'role': 'button'
      });
    });
  });

  $('html[data-page-url="/pages/f-a-q"]').each((i, page) => {
      var ul = $("<ul>");
      var currentH3 = null;

      // Iterate through each element inside .rte
      $(".page-content .rte").children().each(function() {
          if ($(this).is("h3")) {
              // If it's an <h3>, create a new <ul> and <li> for it
              if (currentH3) {
                  ul.append("</ul>");
              }
              currentH3 = $(this);
              ul.append("<li>" + currentH3[0].outerHTML + "</li>");
          } else if (currentH3) {
              // Append other elements to the current <li>
              ul.children("li:last-child").append($(this).clone());
          }
      });

      // Append the final <ul> to .rte
      if (currentH3) {
          ul.append("</ul>");
      }
    
      $(".page-content .rte").append(ul);
      $(".page-content .rte").html(ul);
  });

  $('html[data-page-url="/pages/contact-us"]').each((i, page) => {
    $(page).find('.section-header__title').each((i, el) => {
      insertHiddenClone(el);
    });

    $(page).find('a[href*="returns.richcommerce.co"]').removeAttr('title').attr('aria-label', function() {
      return `${$(this).text().trim()} ${$(this).parent().clone().children().remove().end().text().replace(':', '').trim()}`
    })
  });

  $('.stamped-questions-filter').each((i, questions) => {
    const input = $(questions).find('.stamped-questions-search-input');
    const clear = $(questions).find('.stamped-questions-search-clear');

    clear.on('click', () => {
      input.focus();
    });

    clear.on('keydown', triggerSelfClick);
  });

  $('.stamped-file-uploader').each((i, uploader) => {
    const button = $(uploader).find('.stamped-file-uploader-btn');

    button.attr({
      'role': 'button',
      'tabindex': 0
    })
    .on('keydown', triggerSelfClick);
  });

  $('.stamped-file-holder').each((i, holder) => {
    const observer = new MutationObserver((mutations) => {
      for(const mutation of mutations) {
        for(const node of mutation.addedNodes) {
          console.log(node);
          
          $(node).find('.stamped-file-photo-remove').attr({
            'role': 'button',
            'tabindex': 0,
            'aria-label': function() {
              return `remove ${$(this).prev().text().trim()}`;
            }
          }).on('keydown', triggerSelfClick)
        }
      }
    });

    observer.observe(holder, {
      childList: true
    });
  });

  $('.stamped-summary-actions-newquestion, .stamped-summary-actions-newreview').each((i, button) => {
    button.removeAttribute('onkeydown');
  });

  $('.product__photos').each((i, photos) => {
    $(photos).find('.product-slideshow').removeAttr('tabindex');

    $(photos).find('.product-main-slide').each((i, slide) => {
      const observer = new MutationObserver((mutations) => {
        $(slide).removeAttr('tabindex');
      });

      observer.observe(slide, {
        attributes: true,
        attributeFilter: ['class']
      });
    });

    $(photos).find('.product__thumb').each((i, thumb) => {
      function preventFocusHandler(event) {
        event.preventDefault();
        event.stopPropagation();
      }
      
      // Add the event handler to the element during the capturing phase
      thumb.addEventListener("focus", preventFocusHandler, true);
    });

    $(photos).find('.flickity-page-dots').each((i, wrapper) => {
      const dots = $(wrapper).find('.dot');

      dots.each((i, dot) => {
        const activeImage = $(photos).find('.product-main-slide').eq(i).find('img');
        const activeImageAlt = `${activeImage.attr('alt') || ''}`;

        if(activeImageAlt) {
          $(dot).attr({
            'aria-label': activeImageAlt
          })
        }
      })
    });
    
  });

  $('.template-product .product-block--description-tabs .tab--panel').each((i, panel) => {
    var tabPanel = $(panel);
    var lines = tabPanel.html().split('<br>');
    var ul = $("<div>");
    var currentList = null;

    console.log(panel);
  
    lines.forEach(function (line) {
        line = $.trim(line);
        if (line.startsWith("+ ")) {
            if (!currentList) {
                currentList = $("<ul>");
            }
            var listItem = $("<li>").html(line);
            currentList.append(listItem);
        } else {
            if (currentList) {
                ul.append(currentList);
                currentList = null;
            }
            if (typeof line === "string") {
              ul.append(line);
            }
        }
    });

    // Append the last list, if any
    if (currentList) {
        ul.append(currentList);
    }

    // Replace the content of tabPanel with the updated content
    tabPanel.html(ul);
  });

  $('body.template-index').each((i, page) => {
    $(page).find('.slideshow__slide').each((i, slide) => {
      if(i === 0) {
        const topSubtitle = $(slide).find('.hero__top-subtitle');
        const title = $(slide).find('.hero__title');
        const subtitle = $(slide).find('.hero__subtitle');
        const hiddenTitle = $(`<h1 class="sr-only">${topSubtitle.text().trim()} ${title.text().trim()}</h1>`);

        hiddenTitle.insertBefore(topSubtitle);

        topSubtitle.attr('aria-hidden', true);
        title.attr('aria-hidden', true);

      }
    });

    $(page).find('h1:not(.sr-only)').attr({
      'role': 'heading',
      'aria-level': 2
    });

    const title = $(page).closest('html').find('head title');

    title.text(`Home - ${title.text().trim()}`);
  });

  $('.pagination').each((i, pagination) => {
    $(pagination).find('.current').each((i, current) => {
      const text = $(current).text();
      $(current).text('');
      $(current).append(`<span aria-hidden="true">${text}</span>`);
      $(current).append(`<span class="visually-hidden">Page ${text} current</span>`);
    });
  });

  console.log("Ready");
});

$(window).on("load", function () {
  setTimeout(() => {
    $('.question-form-wrapper').each((i, wrapper) => {      
      $(wrapper).find('.stamped-form-message').each((i, message) => {
        const observer = new MutationObserver((mutations) => {
          const style = getComputedStyle(message);

          if(style.display != 'none') {
            $(message).attr({
              'tabindex': -1
            }).focus();
          }
        });
  
        observer.observe(message, {
          attributes: true,
          attributeFilter: ['style']
        });
      });
    });

    $('.stamped-form-review-rating').each((i, rating_form) => {
      const radioId = randomId();
      
      $(rating_form).find('label[for="reviewRating"]').attr("id", radioId).removeAttr("for");

      $(rating_form).find('input#reviewRating').attr('type', 'hidden');
      
      $(rating_form).find(".stamped-starrating").each((i, rating) => {
        
        $(rating).attr({
          role: "radiogroup",
        });
  
        const icons = rating.querySelectorAll("a.stamped-fa-star-o");
  
        if (icons.length > 0) {
          icons.forEach((star, i) => {
            star.setAttribute("aria-required", true);
            star.setAttribute("role", "radio");
            star.setAttribute("aria-labelledby", radioId);
            star.removeAttribute("aria-label");

            function handleStarChange() {
              if (star.classList.contains("fa-star-checked")) {
                star.setAttribute("aria-checked", true);
              } else {
                star.setAttribute("aria-checked", false);
              }

              queueMicrotask(() => {
                if(star.hasAttribute('aria-pressed')) {
                  star.removeAttribute('aria-pressed')
                }
              });
            }
  
            star.addEventListener("keydown", (e) => {
              const activeIcon = document.activeElement;
              const iconsArray = Array.from(icons);
              const activeIndex = iconsArray.indexOf(activeIcon);
  
              if (e.key === "ArrowDown") {
                e.preventDefault();
                if (activeIndex < icons.length - 1) {
                  icons[i + 1].focus();
                  icons[i + 1].click();
                }
              } else if (e.key === "ArrowUp") {
                e.preventDefault();
                if (activeIndex > 0) {
                  icons[i - 1].focus();
                  icons[i - 1].click();
                }
              } else if (e.key === "ArrowRight") {
                e.preventDefault();
                if (activeIndex < icons.length - 1) {
                  icons[i + 1].focus();
                  icons[i + 1].click();
                }
              } else if (e.key === "ArrowLeft") {
                e.preventDefault();
                if (activeIndex > 0) {
                  icons[i - 1].focus();
                  icons[i - 1].click();
                }
              } else if (e.key === "Tab" && !e.shiftKey) {
                e.preventDefault();
                $(rating_form).next().find(focusableSelector).first().focus()
              } else if (e.key === "Tab" && e.shiftKey) {
                e.preventDefault();
                console.log($(rating_form).parent().prev());
                $(rating_form).parent().prev().find('input.stamped-form-input-email').focus()
              }
            });

            handleStarChange();

            const observer = new MutationObserver(() => {
              handleStarChange();
            });

            observer.observe(star, {
              attributes: true,
              attributeFilter: ['class', 'aria-pressed']
            });
            
          });
        }
      });
    });

    $('afterpay-modal').each((i, modal) => {
      
      function handleChange() {
        console.log(modal.getAttribute('visible'));
        
        if(modal.getAttribute('visible') === 'visible') {
          $(modal).siblings().not('.live-status-region').attr('aria-hidden', true) 
        } else {
          $(modal).siblings().not('.live-status-region').removeAttr('aria-hidden')
        }
      }
  
      const observer = new MutationObserver((mutations) => {
        setTimeout(() => {
          handleChange();
        }, 250);
      });
  
      observer.observe(modal, {
        attributes: true,
        attributeFilter: ['visible']
      });
    });

    $('#customer_login, #recover_email, #create_customer, form[action="/account/recover"], .contact-form').each((i, form) => {
      const errors = $(form).find(".errors > ul");
  
      if (errors.length > 0) {
        errors.attr({
          role: "alert",
        });
      }

      $(form).find('input[aria-describedby], select[aria-describedby], textarea[aria-describedby]').first().focus();

      $(form).find('[name="customer[first_name]"]').attr('autocomplete', 'given-name');
      $(form).find('[name="customer[last_name]"]').attr('autocomplete', 'family-name');
      $(form).find('[name="contact[name]"]').attr('autocomplete', 'name');
      $(form).find('[type="email"]').attr('autocomplete', 'email');
    });    

    $('.octane-ai-quiz-rendered').each((i, quiz) => {
      function handleChange() {
        const title = $(quiz).find('[data-element*="oct-quiz-title"]');
        
        title.attr({
          'role': 'heading',
          'aria-level': 2,
          'tabindex': -1
        });

        $(quiz).removeAttr('tabindex');

        $(quiz).find('.oct-quiz-multiple-choice-options__option, .oct-quiz-picture-choice-options__option').each((i, option) => {
          const title = $(option).attr('title');
            
          function handleOptionChange() {
            $(option).attr({
              'role': 'button',
              'aria-label': `${$(option).children('div').first().text() || title} ${$(option).attr('data-is-option-selected') === 'selected' ? 'selected' : 'not selected'}`
            }).focus();

            $(option).removeAttr('title');
          }

          handleOptionChange();

          const observer = new MutationObserver((mutations) => {
            handleOptionChange();
          });

          observer.observe(option, {
            attributes: true,
            attributeFilter: ['data-is-option-selected']
          })
        });

        $(quiz).find('[data-element*="oct-quiz-input"]').each((i, wrap) => {
          const error = $(wrap).find('[style*="color: rgb(191, 7, 17)"]');
          const input = $(wrap).find('> input');
          const id = randomId();
          
          input.attr({
            'aria-label': `${title.text().trim()}`
          });

          if(error.length > 0) {
            error.attr('id', id);
            input.attr('aria-describedby', id);

            if(error.text().trim() === 'Invalid email') {
              error.text('please enter a valid email eg: yourname@domain.com');
            }

            setTimeout(() => {
              input.focus();
            }, 300);
          }
        });

        $(quiz).find('[data-element*="oct-quiz-multiplechoice"] > ul').attr({
          'role': 'group',
          'aria-label': `${title.text().trim()}`
        });

        setTimeout(() => {
          title.focus();
        }, 250);
      }

      handleChange();
      
      const observer = new MutationObserver((mutations) => {
        handleChange();
      });

      observer.observe(quiz, {
        childList: true
      });
    });

    
    $('.new-review-form, .new-question-form').each((i, form) => {
      const thankYou = $(form).next().find('.stamped-thank-you');
      
      $(form).prepend(
        "<p class='required-indication'>Fields marked with an asterisk (*) are required.</p>"
      );
      
      $(form).find('[required]').each((i, input) => {
        let label = $(input).parent().find("label");

        if(label.length < 1) {
          label = $(input).closest('.stamped-form-review-body').find("label");
        }
        
        if (label.find(".astrisk").length === 0) {
          label.append("<span class='astrisk'>*</span>");
        }
      });

      const observer = new MutationObserver((mutations) => {
        if(thankYou.css('display') === 'block') {
          thankYou.find('p').first().attr('tabindex', -1).focus();
        }
      });

      if(thankYou.length > 0) {
        observer.observe(thankYou.get(0), {
          attributes: true,
          attributeFilter: ['style']
        });
      }
    });

    
    $('.stamped-tabs').each((i, tabs) => {
      $('.stamped-review-avatar').removeAttr('id');
      
      $(tabs).find('#tab-questions').on('click', (e) => {
        setTimeout(() => {
          $('.stamped-review-avatar').removeAttr('id');
        }, 500);
      });
    });

    $('#stamped-questions-tab').each((i, questions) => {
      const observer = new MutationObserver((mutations) => {
        if(questions.hasAttribute('tabindex')) {
          questions.removeAttribute('tabindex');
        }
      });
  
      observer.observe(questions, {
        attributes: true,
        attributeFilter: ['tabindex']
      });
    });

    $('img[src$="5-stars-rating.svg"]').attr('alt', '5 Stars Reviews');


    $('.stamped-sort-select').each((i, select) => {
      $(select).on('change', (e) => {
        const option = $(select).find(`option[value="${e.target.value}"]`);
        setTimeout(() => {
          announceToScreenReader(`Sorted by ${option.text().trim()}`);
        }, 1000);
      });
    });

    $('#NavDrawer, #CartDrawer').each((i, drawer) => {
      const observer = new MutationObserver(() => {
        if(drawer.classList.contains('drawer--is-open')) {
          $(drawer).parents().siblings().attr("aria-hidden", true);
          $(drawer).siblings().attr('aria-hidden', true);
        } else {
          $(drawer).parents().siblings().removeAttr("aria-hidden");
          $(drawer).siblings().removeAttr("aria-hidden");
        }
      });
  
      observer.observe(drawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    });

    $('.template-search').each((i, body) => {
      const title = $(body).closest('html').find('head title');

      announceToScreenReader(title.text().trim());
    });

    $('.payment-icons').each((i, list) => {
      $(list).attr('role', 'list');
      $(list).find('li').attr('role', 'listitem');
    });

    $(".template-customers-login").each((i, body) => {
      const page = $(body).closest('html');
      page.find('head title').text('Account Login – VETCHY');
    });

    $(".template-customers-register, .template-customers-login").each((i, body) => {
      $(body).find('.errors ul').removeAttr('role');
      $(body).find('.errors li').first().attr({
        'tabindex': -1,
        'role': 'alert'
      }).focus();
    });

    $('#meta-pay-button__a, #meta-pay-button__b, #address-edit-toggle, #addresses-update-submit').removeAttr('id');
    
  }, 500);

  setTimeout(() => {
    $('linearGradient').each((i, el) => {
      el.removeAttribute('id');
    });
  }, 250);

  
  function handleReviewItem(review) {
    
    const shareBtn = $(review).find('.stamped-share-icon');
    const title = $(review).find('.stamped-review-header-title');
    const ratingHolder = $(review).find('.stamped-rating-holder');

    ratingHolder.attr({
      'role': 'group',
      'aria-label': function() {
        return $(this).contents().filter(function() {
          return this.nodeType === 3;
        }).first().text().trim();
      }
    });
  
    shareBtn.attr({
      'aria-label': `${shareBtn.text().trim()} (${title.text().trim()})`
    }); 

    $(review).find('.stamped-thumbs-up, .stamped-thumbs-down').each((i, button) => {
      const ariaLabel = $(button).attr('aria-label');
      
      function handleChange() {
        const isMobile = window.matchMedia("(max-width: 767px)");
        
        $(button).attr({
          'aria-label': function() {
            return `${ariaLabel} (${title.text().trim()}) - ${button.textContent.trim()} votes`
          }
        });

        if(isMobile.matches) {
          announceToScreenReader(`${ariaLabel} (${title.text().trim()}) - ${button.textContent.trim()} votes`);
        }
      }

      handleChange();

      const observer = new MutationObserver((mutations) => {
        handleChange();
      });

      observer.observe(button, {
        childList: true,
        subtree: true,
      });
    });

    $(review).find('.stamped-starratings').attr({
      'role': 'img'
    });

  }

  $('.stamped-reviews').each((i, reviews) => {    
    function handleDisabledLink() {
      $(reviews).find('.stamped-link-disabled').attr('tabindex', -1).removeAttr('href');
    }

    function handlePagination() {
      const pagination = $(reviews).find('.stamped-pagination');
      pagination.find('.active a').attr('aria-current', 'page');
    }

    handlePagination();
    
    const observer = new MutationObserver((mutations) => {    
      
      for(const mutation of mutations) {        
        for(const node of mutation.addedNodes) {
          if(node.tagName === "SPAN") {
            announceToScreenReader(`${node.textContent}`)
          }
          
          if(!node || !node.classList) {
            continue
          }

          if(node.classList.contains('stamped-review')) {
            handleReviewItem(node);
          }          
        }
      }

      handleDisabledLink();
      handlePagination();
    });

    handleDisabledLink();

    observer.observe(reviews, {
      childList: true,
    });
    
    $(reviews).find('.stamped-review').each((i, review) => {
      handleReviewItem(review);
    });

    // reviews.removeAttribute('tabindex');

    const tabindexObserver = new MutationObserver((mutations) => {
      if(reviews.hasAttribute('tabindex')) {
        reviews.removeAttribute('tabindex');
      }
    });

    tabindexObserver.observe(reviews, {
      attributes: true,
      attributeFilter: ['tabindex']
    });
  });

  
  console.log('load');
});

let liveElementTimeout = null;

function announceToScreenReader(text, role, timeout = 1000, once = false) {
  if (once && liveElementTimeout) {
    return;
  }

  const liveElement = document.querySelector(".live-status-region");
  const paraElement = document.createElement("p");
  const textElement = document.createTextNode(text);

  if (!liveElement) {
    return;
  }

  liveElement.setAttribute("role", role === undefined ? "status" : role);
  paraElement.appendChild(textElement);
  liveElement.appendChild(paraElement);

  liveElementTimeout = setTimeout(() => {
    liveElement.innerHTML = "";
    liveElement.setAttribute("role", "status");
	liveElementTimeout = null;
  }, timeout);
}

function randomId(length = 10) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}


function trapFocus(element) {
  const $ = jQuery;

  const focusableElements = $(element).find(focusableSelector);
  
  focusableElements.first().focus();

  focusableElements.last().on("keydown", (e) => {
    if (e.originalEvent.code === "Tab" && !e.originalEvent.shiftKey) {
      e.preventDefault();
      focusableElements.first().focus();
    }
  });

  focusableElements.first().on("keydown", (e) => {
    if (e.originalEvent.code === "Tab" && e.originalEvent.shiftKey) {
      e.preventDefault();
      focusableElements.last().focus();
    }
  });
}

function insertHiddenClone(element) {
  const $element = $(element);
  const headingClone = $(element).clone();
  headingClone.text($element.text().toLowerCase());
  headingClone.addClass("sr-only lowercase");

  $(headingClone).insertBefore(element);

  $element.attr({
    "aria-hidden": true,
  });
}